// extracted by mini-css-extract-plugin
module.exports = {"select":"CompanySelect_select__mFzdh"};